import { defineComponent as _defineComponent } from 'vue'
import QMyStatsSubmenu from '@/components/navigation/Submenus/QMyStatsSubmenu.vue';
import QLeaderboardDataTableWrapper from '@/components/datatables/QLeaderboardDataTableWrapper.vue'
import QBusinessTimePeriodSelect from '@/components/utils/QBusinessTimePeriodSelect.vue';
import QDataTableHeader from '../../components/datatables/base/QDataTableHeader.vue'
import { computed, ref } from "vue";
import { getCurrentInstance } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Leaderboards',
  setup(__props) {

const datePeriod = ref({ label: 'Current Month', 'period': 'month' })
const time_period = computed(() => {
  const timePeriodMap = {
	week: 'weekly',
	month: 'monthly',
	year: 'yearly',
  };

  return timePeriodMap[datePeriod.value.period];
})


return { __sfc: true,datePeriod, time_period, QMyStatsSubmenu, QLeaderboardDataTableWrapper, QBusinessTimePeriodSelect, QDataTableHeader }
}

})